import { render } from "./PriorityImportAndImportDestination.vue?vue&type=template&id=75ef5379&scoped=true"
import script from "./PriorityImportAndImportDestination.vue?vue&type=script&lang=js"
export * from "./PriorityImportAndImportDestination.vue?vue&type=script&lang=js"

import "./PriorityImportAndImportDestination.vue?vue&type=style&index=0&id=75ef5379&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ef5379"]])

export default __exports__